module.exports = __webpack_public_path__ + "img/no-management.20dcfaf0.png";